export default "__VITE_ASSET__DqPkv11E__"